<template>
  <v-chip label
          small
          :color="color"
          dark
          class="text-center font-weight-bold"
          :class="{'d-block': block}"
          text-color="white">
    {{ campaign.status }}
  </v-chip>
</template>
<script>
export default {
  props: {
    block: {
      type: Boolean,
      default: true,
    },
    campaign: {
      type: Object,
    },
    size: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    color() {
      if (this.campaign.is_sent) {
        return 'green';
      } else if (this.campaign.is_canceled) {
        return 'red';
      }
      return 'orange';
    },
  }
}
</script>
